import React, { Component } from "react";
import Auth from "../auth";
import { Route, Switch, Link } from "react-router-dom";

export default class Header extends Component {
  render() {
    const name = localStorage.getItem("userData")
      ? JSON.parse(localStorage.getItem("userData")).name.split(" ")[1]
        ? JSON.parse(localStorage.getItem("userData")).name.split(" ")[0] +
          " " +
          JSON.parse(localStorage.getItem("userData")).name.split(" ")[1]
        : JSON.parse(localStorage.getItem("userData")).name.split(" ")[0]
      : "";
    const full_name = localStorage.getItem("userData")
      ? JSON.parse(localStorage.getItem("userData")).name
      : "";
    const auth = new Auth();
    return (
      <div>
        {/* Header */}
        {/* Topnav */}
        <nav className="navbar navbar-top navbar-expand navbar-dark bg-success border-bottom">
          <div className="container-fluid">
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              {/* Search form */}
              {/* <form
                className="navbar-search navbar-search-light form-inline mr-sm-3"
                id="navbar-search-main"
              > */}
                {/* <div className='form-group mb-0'>
                  <div className='input-group input-group-alternative input-group-merge'>
                    <div className='input-group-prepend'>
                      <span className='input-group-text'>
                        <i className='fas fa-search' />
                      </span>
                    </div>
                    <input
                      className='form-control'
                      placeholder='Search'
                      type='text'
                    />
                  </div>
                </div> */}
                {/* <button
                  type="button"
                  className="close"
                  data-action="search-close"
                  data-target="#navbar-search-main"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </form> */}
              {/* Navbar links */}
              <ul className="navbar-nav align-items-center ml-md-auto">
                <li className="nav-item d-xl-none">
                  {/* Sidenav toggler */}
                  <div
                    className="pr-3 sidenav-toggler sidenav-toggler-dark"
                    data-action="sidenav-pin"
                    data-target="#sidenav-main"
                  >
                    <div className="sidenav-toggler-inner">
                      <i className="sidenav-toggler-line" />
                      <i className="sidenav-toggler-line" />
                      <i className="sidenav-toggler-line" />
                    </div>
                  </div>
                </li>
                {/* <li className="nav-item d-sm-none">
                  <a
                    className="nav-link"
                    href="# "
                    data-action="search-show"
                    data-target="#navbar-search-main"
                  >
                    <i className="ni ni-zoom-split-in" />
                  </a>
                </li> */}
              </ul>
              <ul className="navbar-nav align-items-center ml-auto ml-md-0">
                <li className="nav-item dropdown">
                  <a
                    className="nav-link pr-0"
                    href="# "
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div className="media align-items-center">
                      {/* <div className="media-body ml-2 d-none d-lg-block"> */}
                      <div>
                        <span className="mb-0 font-weight-bold">{name}</span>
                      </div>
                    </div>
                  </a>
                  <div className="dropdown-menu dropdown-menu-right">
                    <div className="dropdown-header noti-title">
                      <h6 className="text-overflow m-0">{full_name}</h6>
                    </div>
                    <Link className="dropdown-item" to={`/profil`}>
                      <i className="ni ni-circle-08" />
                      <span>profile</span>
                    </Link>

                    <a
                      href="#!"
                      className="dropdown-item"
                      onClick={() => auth.logout()}
                    >
                      <i className="ni ni-user-run" />
                      <span>Logout</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}
